import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { 
  LightMode as LightModeIcon,
  DarkMode as DarkModeIcon
} from '@mui/icons-material';

export interface ThemeToggleProps {
  isDark: boolean;
  onToggle: () => void;
  size?: 'small' | 'medium' | 'large';
  showTooltip?: boolean;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({
  isDark,
  onToggle,
  size = 'medium',
  showTooltip = true
}) => {
  const getSizeProps = () => {
    switch (size) {
      case 'small':
        return { iconSize: 20, buttonSize: 32 };
      case 'large':
        return { iconSize: 28, buttonSize: 48 };
      default:
        return { iconSize: 24, buttonSize: 40 };
    }
  };

  const sizeProps = getSizeProps();

  const button = (
    <IconButton
      onClick={onToggle}
      size={size === 'small' ? 'small' : size === 'large' ? 'large' : 'medium'}
      sx={{
        width: sizeProps.buttonSize,
        height: sizeProps.buttonSize,
        transition: 'all 300ms ease-in-out',
        '&:hover': {
          transform: 'scale(1.1)',
        },
      }}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? (
        <LightModeIcon sx={{ fontSize: sizeProps.iconSize }} />
      ) : (
        <DarkModeIcon sx={{ fontSize: sizeProps.iconSize }} />
      )}
    </IconButton>
  );

  if (showTooltip) {
    return (
      <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
        {button}
      </Tooltip>
    );
  }

  return button;
};

export default ThemeToggle;
